import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [openSubDropdown, setOpenSubDropdown] = useState<string | null>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Блок с акцией */}
      <div className="fixed top-0 left-0 right-0 z-50 w-full" style={{ background: 'linear-gradient(90deg, rgba(30, 173, 229, 1) 0%, rgba(100, 30, 229, 1) 50%, rgba(179, 30, 229, 1) 100%)' }}>
        <div className="max-w-[1360px] mx-auto px-6 py-3">
          <div className="flex items-center justify-center space-x-4">
            <span className="text-white font-mulish font-semibold text-base">Путешествие на край земли!</span>
            <button className="bg-[#0FA03C] text-white px-6 py-2 rounded-lg font-mulish font-semibold text-sm hover:bg-[#0d8a33] transition-colors whitespace-nowrap cursor-pointer">
              Подробнее
            </button>
          </div>
        </div>
      </div>

      {/* Верхняя информационная панель */}
      <div className={`fixed top-[52px] left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white border-b border-gray-200' : 'bg-transparent'}`}>
        <div className="max-w-[1360px] mx-auto px-6">
          <div className="flex items-center justify-between py-3">
            {/* Левая часть - выпадающее меню "О компании" */}
            <div className="flex items-center space-x-6">
              <div 
                className="relative"
                onMouseEnter={() => setOpenDropdown('company')}
                onMouseLeave={() => setOpenDropdown(null)}
              >
                <button className={`flex items-center space-x-1 text-sm transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                  <span>О компании</span>
                  <i className="ri-arrow-down-s-line text-base"></i>
                </button>
                {openDropdown === 'company' && (
                  <div className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-lg py-2 min-w-[180px] z-50">
                    <Link to="/about" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1E88E5] transition-colors whitespace-nowrap cursor-pointer">О нас</Link>
                    <Link to="/team" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1E88E5] transition-colors whitespace-nowrap cursor-pointer">Команда</Link>
                  </div>
                )}
              </div>
              <Link to="/articles" className={`text-sm transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>Статьи</Link>
              <Link to="/services" className={`text-sm transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>Услуги</Link>
              <Link to="/contacts" className={`text-sm transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>Контакты</Link>
            </div>

            {/* Правая часть - время работы и соцсети */}
            <div className="hidden lg:flex items-center space-x-8">
              <div className={`text-sm ${isScrolled ? 'text-gray-600' : 'text-white'}`}>
                Пн-Пт: 10:00–20:00 | Сб: 11:00–18:00
              </div>
              <div className="flex items-center space-x-3">
                <a href="https://vk.com/yourpage" target="_blank" rel="noopener noreferrer" className={`w-9 h-9 flex items-center justify-center transition-colors cursor-pointer ${isScrolled ? 'text-gray-600 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                  <i className="ri-vk-line text-2xl"></i>
                </a>
                <a href="https://t.me/yourtelegram" target="_blank" rel="noopener noreferrer" className={`w-9 h-9 flex items-center justify-center transition-colors cursor-pointer ${isScrolled ? 'text-gray-600 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                  <i className="ri-telegram-line text-2xl"></i>
                </a>
                <a href="https://youtube.com/yourchannel" target="_blank" rel="noopener noreferrer" className={`w-9 h-9 flex items-center justify-center transition-colors cursor-pointer ${isScrolled ? 'text-gray-600 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                  <i className="ri-youtube-line text-2xl"></i>
                </a>
                <a href="https://dzen.ru/yourpage" target="_blank" rel="noopener noreferrer" className={`w-9 h-9 flex items-center justify-center transition-colors cursor-pointer ${isScrolled ? 'text-gray-600 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                  <svg className={`w-6 h-6 ${isScrolled ? 'fill-gray-600 hover:fill-[#1E88E5]' : 'fill-white hover:fill-white/80'}`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Основная навигация */}
      <header className={`fixed top-[104px] left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-[1360px] mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            {/* Логотип */}
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/c54bf300b62b5700ba235bc10fb45585/3485c0c87e80c7951429fa2205da08c7.png" 
                alt="Логотип" 
                className={`h-12 w-auto transition-all duration-300 ${isScrolled ? '' : 'brightness-0 invert'}`}
              />
            </Link>

            {/* Основное меню */}
            <nav className="hidden lg:flex items-center space-x-6">
              {/* Путешествия */}
              <Link to="/travels" className={`flex items-center space-x-1 font-mulish font-semibold text-base transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                <span>Путешествия</span>
                <i className="ri-search-line text-base"></i>
              </Link>

              {/* По России */}
              <div 
                className="relative"
                onMouseEnter={() => {
                  setOpenDropdown('russia');
                  setOpenSubDropdown(null);
                }}
                onMouseLeave={() => {
                  setOpenDropdown(null);
                  setOpenSubDropdown(null);
                }}
              >
                <button className={`flex items-center space-x-1 font-mulish font-semibold text-base transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                  <span>По России</span>
                  <i className="ri-arrow-down-s-line text-base"></i>
                </button>
                
                {openDropdown === 'russia' && (
                  <div className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-xl py-2 min-w-[280px] z-50">
                    {[1, 2, 3, 4].map((section) => (
                      <div 
                        key={`russia-${section}`}
                        className="relative"
                        onMouseEnter={() => setOpenSubDropdown(`russia-${section}`)}
                      >
                        <button className="w-full flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1E88E5] transition-colors cursor-pointer">
                          <span>Подраздел по России {section}</span>
                          <i className="ri-arrow-right-s-line text-base"></i>
                        </button>
                        {openSubDropdown === `russia-${section}` && (
                          <div className="absolute left-full top-0 ml-1 bg-white rounded-lg shadow-xl py-2 min-w-[240px] z-50">
                            {[1, 2, 3, 4, 5, 6, 7].map((page) => (
                              <Link 
                                key={`russia-${section}-${page}`}
                                to={`/russia/section-${section}/tour-${page}`} 
                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1E88E5] transition-colors whitespace-nowrap cursor-pointer"
                              >
                                Страница тура по России {page}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* По Миру */}
              <div 
                className="relative"
                onMouseEnter={() => {
                  setOpenDropdown('world');
                  setOpenSubDropdown(null);
                }}
                onMouseLeave={() => {
                  setOpenDropdown(null);
                  setOpenSubDropdown(null);
                }}
              >
                <button className={`flex items-center space-x-1 font-mulish font-semibold text-base transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                  <span>По Миру</span>
                  <i className="ri-arrow-down-s-line text-base"></i>
                </button>
                
                {openDropdown === 'world' && (
                  <div className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-xl py-2 min-w-[280px] z-50">
                    {[1, 2, 3, 4].map((section) => (
                      <div 
                        key={`world-${section}`}
                        className="relative"
                        onMouseEnter={() => setOpenSubDropdown(`world-${section}`)}
                      >
                        <button className="w-full flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1E88E5] transition-colors cursor-pointer">
                          <span>Подраздел по Миру {section}</span>
                          <i className="ri-arrow-right-s-line text-base"></i>
                        </button>
                        {openSubDropdown === `world-${section}` && (
                          <div className="absolute left-full top-0 ml-1 bg-white rounded-lg shadow-xl py-2 min-w-[240px] z-50">
                            {[1, 2, 3, 4, 5, 6, 7].map((page) => (
                              <Link 
                                key={`world-${section}-${page}`}
                                to={`/world/section-${section}/tour-${page}`} 
                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1E88E5] transition-colors whitespace-nowrap cursor-pointer"
                              >
                                Страница тура по Миру {page}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Виды отдыха */}
              <div 
                className="relative"
                onMouseEnter={() => {
                  setOpenDropdown('types');
                  setOpenSubDropdown(null);
                }}
                onMouseLeave={() => {
                  setOpenDropdown(null);
                  setOpenSubDropdown(null);
                }}
              >
                <button className={`flex items-center space-x-1 font-mulish font-semibold text-base transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                  <span>Виды отдыха</span>
                  <i className="ri-arrow-down-s-line text-base"></i>
                </button>
                
                {openDropdown === 'types' && (
                  <div className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-xl py-2 min-w-[280px] z-50">
                    {[1, 2, 3, 4].map((section) => (
                      <div 
                        key={`types-${section}`}
                        className="relative"
                        onMouseEnter={() => setOpenSubDropdown(`types-${section}`)}
                      >
                        <button className="w-full flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1E88E5] transition-colors cursor-pointer">
                          <span>Подраздел по видам отдыха {section}</span>
                          <i className="ri-arrow-right-s-line text-base"></i>
                        </button>
                        {openSubDropdown === `types-${section}` && (
                          <div className="absolute left-full top-0 ml-1 bg-white rounded-lg shadow-xl py-2 min-w-[280px] z-50">
                            {[1, 2, 3, 4, 5, 6, 7].map((page) => (
                              <Link 
                                key={`types-${section}-${page}`}
                                to={`/types/section-${section}/tour-${page}`} 
                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1E88E5] transition-colors whitespace-nowrap cursor-pointer"
                              >
                                Страница тура по видам отдыха {page}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Отзывы */}
              <Link to="/reviews" className={`font-mulish font-semibold text-base transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                Отзывы
              </Link>

              {/* Компаниям */}
              <Link to="/corporate" className={`font-mulish font-semibold text-base transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                Компаниям
              </Link>

              {/* Индивидуально */}
              <Link to="/individual" className={`font-mulish font-semibold text-base transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                Индивидуально
              </Link>
            </nav>

            {/* Правая часть - поиск и телефон */}
            <div className="flex items-center space-x-4">
              <button className={`w-9 h-9 flex items-center justify-center transition-colors cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                <i className="ri-search-line text-2xl"></i>
              </button>
              <a href="tel:+74951043428" className={`hidden md:flex items-center transition-colors cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                <span className="font-open-sans text-sm whitespace-nowrap">+7 495 104-34-28</span>
              </a>
              <a href="https://api.whatsapp.com/send/?phone=79299141555" target="_blank" rel="noopener noreferrer" className={`w-9 h-9 flex items-center justify-center transition-colors cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}>
                <i className="ri-whatsapp-line text-2xl"></i>
              </a>
              
              {/* Мобильное меню */}
              <button 
                className={`lg:hidden w-9 h-9 flex items-center justify-center transition-colors cursor-pointer ${isScrolled ? 'text-gray-800 hover:text-[#1E88E5]' : 'text-white hover:text-white/80'}`}
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Мобильное меню */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200">
            <div className="max-w-[1360px] mx-auto px-6 py-4">
              <nav className="space-y-3">
                <Link to="/travels" className="block py-2 text-gray-800 hover:text-[#1E88E5] transition-colors cursor-pointer">Путешествия</Link>
                <Link to="/russia" className="block py-2 text-gray-800 hover:text-[#1E88E5] transition-colors cursor-pointer">По России</Link>
                <Link to="/world" className="block py-2 text-gray-800 hover:text-[#1E88E5] transition-colors cursor-pointer">По Миру</Link>
                <Link to="/types" className="block py-2 text-gray-800 hover:text-[#1E88E5] transition-colors cursor-pointer">Виды отдыха</Link>
                <Link to="/reviews" className="block py-2 text-gray-800 hover:text-[#1E88E5] transition-colors cursor-pointer">Отзывы</Link>
                <Link to="/corporate" className="block py-2 text-gray-800 hover:text-[#1E88E5] transition-colors cursor-pointer">Компаниям</Link>
                <Link to="/individual" className="block py-2 text-gray-800 hover:text-[#1E88E5] transition-colors cursor-pointer">Индивидуально</Link>
                <Link to="/about" className="block py-2 text-gray-800 hover:text-[#1E88E5] transition-colors cursor-pointer">О компании</Link>
              </nav>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
